<div class="min-h-screen flex flex-col" style="background-color: var(--mat-sys-background);">
  <main class="grow flex items-center justify-center p-4">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
